import { getIntegrationDisplayName } from '@littlebird/ui-utils';

import { HubspotIcon } from '@/assets/icons/brand-mark-icons';
import { LittlebirdMarkIcon } from '@/assets/icons/littlebird-mark';
import { getIntegrationIcon } from '@/integrations/integration-icons';

import type { ComponentType } from 'react';

type ProviderIdentity = {
  icon: ComponentType<{ className?: string }>;
  name: string;
};

// Providers the integration lists have no entry for: Littlebird is not an
// integration, and HubSpot's mark lives with the brand marks
const OWN: Record<string, ProviderIdentity> = {
  littlebird: { icon: LittlebirdMarkIcon, name: 'Littlebird' },
  hubspot: { icon: HubspotIcon, name: 'HubSpot' },
};

export const providerIcon = (provider: string): ProviderIdentity['icon'] =>
  OWN[provider]?.icon ?? getIntegrationIcon(provider);

export const providerName = (provider: string): string =>
  OWN[provider]?.name ?? getIntegrationDisplayName(provider);
